import { getSalesRankingAvailableYearMonths } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetAvailableMonthsServiceDTO } from './available-year-month.dto';
import { GetAvailableMonthsServiceDTOSchema } from './available-year-month.dto';

const transformAvailableYearMonthsResponse = async (): Promise<GetAvailableMonthsServiceDTO> => {
  const { data } = await getSalesRankingAvailableYearMonths();

  return data.yearMonths.map((yearMonth) => ({
    year: yearMonth.year,
    month: yearMonth.month,
    displayText: `${yearMonth.year}.${String(yearMonth.month).padStart(2, '0')}`,
  }));
};

export const getSalesRankingAvailableYearMonthsService = withServiceErrorCapture(
  lazyPipe(
    transformAvailableYearMonthsResponse,
    validateServiceResponse(GetAvailableMonthsServiceDTOSchema),
  ),
);
